export default __webpack_public_path__ + "sent-ok-e1248c922fe1977ad7cce6935e3b3af5.svg";